import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from 'app/components/header/header.component';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { BukkuServicesComponent } from './components/bukku-services/bukku-services.component';
import { BukkuPricingPlanComponent } from './components/bukku-pricing-plan/bukku-pricing-plan.component';
import { BukkuBannerComponent } from './components/bukku-banner/bukku-banner.component';
import { BukkuFormComponent } from './components/bukku-form/bukku-form.component';

@Component({
    selector: 'app-bukku',
    standalone: true,
    imports: [
        HeaderComponent,
        TranslateModule,
        FooterComponent,
        BukkuServicesComponent,
        BukkuPricingPlanComponent,
        BukkuBannerComponent,
        BukkuFormComponent,
    ],
    templateUrl: './bukku.component.html',
    styleUrl: './bukku.component.scss',
})
export class BukkuComponent implements OnInit {
    selectedLanguage: string = 'en';
    data: any;

    constructor() {
        this.data = history.state.data;
    }

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }
}
